import $http from '../utils/http'

// 获取生产环境小程序urlLink
export const getUrlLink = (params) => {
  return $http.request({
    url: `/roadparking/smsUrlConfig/getSmsUrlByCode`,
    method: 'get',
    params
  })
}
// 获取测试环境小程序urlLink
export const getTestUrlLink = (params) => {
  return $http.request({
    baseURL:'https://gateway.svrehome.com',
    url: `/roadparking/smsUrlConfig/getSmsUrlByCode`,
    method: 'get',
    params
  })
}

